import { makeStyles } from '@mui/styles';
import { COLORS, FONT_WEIGHTS } from '../../../ObeeTheme';

const useStyles = makeStyles((theme) => ({
  flex: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  premiumLabel: {
    color: theme.colors.WHITE,
    backgroundColor: theme.colors.OLIVE_4,
    padding: '6px 11px',
    ...theme.typography.body.P,
    borderRadius: '4px',
    letterSpacing: 1.5,
  },
  restaurantSwitcherContainer: {
    display: 'flex',
    backgroundColor: theme.colors.PALE_MINT,
    borderRadius: '100px',
    height: '55px',
    alignItems: 'center',
    padding: '10px 20px 10px 10px',
    margin: '20px 24px 12px 0',
    color: theme.colors.CHARCOAL,
    gap: '10px',
    cursor: 'pointer',
    userSelect: 'none',
    position: 'relative',
  },
  restaurantName: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    ...theme.typography.heading.H4,
    fontWeight: FONT_WEIGHTS.MEDIUM,
    width: '100%',
  },
  restaurantAddress: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    ...theme.typography.body.subText,
  },
  venueSelectorTitle: {
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    ...theme.typography.body.subText,
    fontWeight: FONT_WEIGHTS.MEDIUM,
    color: COLORS.SMOKE,
  },
  menuItem: {
    margin: '8px',
    borderRadius: '8px',
    minWidth: '260px',
    minHeight: '50px',
  },
  accountMenuWrapper: {
    maxWidth: '100%',
    lineHeight: 'normal',
  },
  popupRestaurantSwitcherContainer: {
    display: 'inline-flex',
    backgroundColor: theme.colors.PALE_MINT,
    borderRadius: '100px',
    height: '55px',
    minWidth: '246px',
    maxWidth: '100%',
    alignItems: 'center',
    padding: '10px 20px 10px 10px',
    margin: '20px 24px 12px 0',
    color: theme.colors.CHARCOAL,
    gap: '10px',
    cursor: 'pointer',
    userSelect: 'none',
    position: 'relative',
    pointerEvents: 'auto',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
    },
  },
  accountMenuContent: {
    pointerEvents: 'auto',
    backgroundColor: 'white',
    // padding: '24px',
    borderRadius: '28px',
    // width: '100%',
    minWidth: '380px',
    maxWidth: '600px',
    ...theme.typography.body.PL,
    lineHeight: 'normal',
    [theme.breakpoints.down('sm')]: {
      minWidth: 'auto',
    },
  },
  navigationLinks: {
    display: 'flex',
    flexDirection: 'column',
    lineHeight: '24px',
    padding: '18px 24px',
    gap: '4px',
    maxHeight: '300px',
    overflowY: 'scroll',
    flexShrink: 0,
    flexGrow: 0,
  },
  navigationLink: {
    padding: '12px',
    borderRadius: '6px',
    cursor: 'pointer',
    userSelect: 'none',
    display: 'flex',
    gap: '8px',
    fontSize: '15px',
    color: COLORS.GREEN_BLACK,
    marginLeft: '-12px',
    marginRight: '-12px',
    '&:hover': {
      backgroundColor: theme.colors.PALE_MINT,
    },
  },
  logoContainer: {
    width: '70px',
    height: '70px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.colors.LIGHT_SHADE,
    borderRadius: '10px',
    fontSize: '42px',
  },
  linkedVenueName: {
    fontWeight: FONT_WEIGHTS.MEDIUM,
  },
  linkedVenueAddress: {
    color: COLORS.SMOKE,
  },

  bottomLink: {
    padding: '18px 28px',
    borderRadius: ' 0  0 28px 28px',
    cursor: 'pointer',
    userSelect: 'none',
    display: 'flex',
    gap: '12px',
    fontSize: '15px',
    alignItems: 'center',
    color: COLORS.BLACK,
    '&:hover': {
      backgroundColor: theme.colors.PALE_MINT,
    },
  },
  linkIcon: {
    display: 'flex',
    alignItems: 'center',
  },
}));

export default useStyles;
